var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-wrapper text-center"},[_c('v-img',{style:(_vm.styles),attrs:{"src":_vm.source},on:{"load":_vm.handleImageLoaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }